// @ts-check
/**
 * @file outbox.js
 * @location src/utils/outbox.js
 * @role 실패한 RPC 호출을 큐에 적재 → 온라인 복귀 시 재시도용. pure 헬퍼만.
 *
 *  큐는 store state 의 일부(`S.outbox`) 로 영속(PERSISTENT_KEYS).
 *  발사·재시도 로직은 useSupabaseStore 가 담당, 이 모듈은 데이터 변형만.
 *
 *  엔트리: { id, type, payload, attempts, createdAt }
 *    id        — 클라이언트 발급 uuid (entry 식별, payload 안의 task.id 와 무관)
 *    type      — ACTION_HANDLERS 의 키 (e.g. 'EDIT_TASK')
 *    payload   — wrappedAct 에 전달된 patch 그대로
 *    attempts  — 누적 발사 횟수 (디버그용)
 *    createdAt — Date.now() — STALE_MS 초과 시 자동 drop
 */

export const MAX_OUTBOX = 100;
export const STALE_MS = 7 * 24 * 60 * 60 * 1000;   // 7일

/** 새 엔트리를 큐 끝에 추가. MAX_OUTBOX 건 초과 시 가장 오래된 것부터 drop. */
export function addEntry(outbox, entry, now) {
  const next = [...outbox, {
    id: entry.id,
    type: entry.type,
    payload: entry.payload,
    attempts: 0,
    createdAt: now,
  }];
  return next.length > MAX_OUTBOX ? next.slice(next.length - MAX_OUTBOX) : next;
}

/** id 매칭 엔트리 1건 제거 (flush 성공 시). */
export function removeEntry(outbox, id) {
  return outbox.filter(e => e.id !== id);
}

/** stale 판정 — createdAt 으로부터 STALE_MS 초과. */
export function isStale(entry, now) {
  return now - entry.createdAt > STALE_MS;
}

/** stale 엔트리 일괄 제거. */
export function dropStaleEntries(outbox, now) {
  return outbox.filter(e => !isStale(e, now));
}
